import React from 'react';
import styled from 'styled-components';
import {
    Window,
    WindowContent,
    WindowHeader,
    Button,
    Bar,
    Toolbar,
    Panel,
    Desktop,
    Hourglass 
} from 'react95';

const Wrapper = styled.div`
  background: teal;
  position: absolute;
  left: ${window.innerWidth * .01}%;
  top: 10%;
  .window-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .close-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: -1px;
    margin-top: -1px;
    transform: rotateZ(45deg);
    position: relative;
    &:before,
    &:after {
      content: '';
      position: absolute;
      background: ___CSS_0___;
    }
    &:before {
      height: 100%;
      width: 3px;
      left: 50%;
      transform: translateX(-50%);
    }
    &:after {
      height: 3px;
      width: 100%;
      left: 0px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .window {
    width: 400px;
    min-height: 200px;
  }
  .window:nth-child(2) {
    margin: 2rem;
  }
  .footer {
    display: block;
    margin: 0.25rem;
    height: 31px;
    line-height: 31px;
    padding-left: 0.25rem;
  }
`;

const MyComputer = (props) => {
    return (
        <Wrapper>
        <Window className='window'>
        <WindowHeader className='window-header'>
            <span>My Computer</span>
            <Button onClick={() => props.visibleComp()}>
                <span className='close-icon'>X</span>
            </Button>
        </WindowHeader>
        <Toolbar>
            <Button variant='menu' size='sm' primary>
            File
            </Button>
            <Bar size={35} />
            <Button variant='menu' size='sm'>
            Edit
            </Button>
            <Bar size={35} />
            <Button variant='menu' size='sm'>
            View
            </Button>
            <Bar size={35} />
            <Button variant='menu' size='sm'>
            Tools
            </Button>
            <Bar size={35} />
            <Button variant='menu' size='sm'>
            Help
            </Button>
        </Toolbar>
        <WindowContent>
            <div>
              <Hourglass size={32} />
            </div>
            <Desktop backgroundStyles={{ background: 'blue' }} />
            <p>
              Not working :/
            </p>
        </WindowContent>
        <Panel variant='well' className='footer'>
            🐛 bugss
        </Panel>
        </Window>
    </Wrapper >
    );
};

export default MyComputer;
